const envSettings = window as any

export class Config {
    static apiUrl = envSettings.ENVIRONMENT.SERVER_URL
    static chronografUrl = envSettings.ENVIRONMENT.CHRONOGRAF_URL
    static token = envSettings.ENVIRONMENT.TOKEN
}
